import ModelArticle from './ModelArticle';
import { keywordSets } from '../PageSeo';
import { vehiclePrices } from '../vehiclePrices';
import banner2026 from '../images/danza-d9-2026/d9-banner-2026.jpg';
import colorBlue from '../images/danza-d9-2026/color-blue.png';
import colorBlack from '../images/danza-d9-2026/color-black.png';
import colorGrey from '../images/danza-d9-2026/color-grey.png';
import interiorBrown from '../Asset/interior-brown.webp';
import interiorCabin from '../Asset/interior.webp';
import sunroof from '../Asset/m07-pc-skylight.webp';

const STUDIO_BG = 'linear-gradient(180deg, #f8fafc 0%, #dfe5ec 100%)';

const PRICE = vehiclePrices.denzaD9[0];

export const d9Nik2026ArticleMeta = {
  slug: 'danza-d9-nik-2026-generasi-kedua',
  title: `Danza D9 NIK 2026 Generasi Kedua: Harga ${PRICE.price}, Apa yang Baru?`,
  description:
    'Danza D9 NIK 2026 hadir sebagai generasi kedua: Blade Battery 2.0 115 kWh, tenaga 340 kW, jarak 730 km NEDC, Flash Charging 9 menit, DiSus-C, Devialet 16 speaker, 9 airbag, dan interior baru Black. Harga Rp1.080.000.000 OTR Jakarta.',
  image: banner2026,
  contentLength: '1000 kata',
};

const article = {
  slug: d9Nik2026ArticleMeta.slug,
  metaTitle: d9Nik2026ArticleMeta.title,
  metaDescription: d9Nik2026ArticleMeta.description,
  keywords: [
    ...keywordSets.danzaD9,
    ...keywordSets.danza,
    ...keywordSets.localDealer,
    'Danza D9 generasi kedua',
    'Danza D9 2nd generation',
    'New Danza D9',
    'Danza D9 vs Denza D9 lama',
  ],
  datePublished: '2026-11-01',
  heroImage: banner2026,
  heroAlt: 'New Danza D9 NIK 2026 generasi kedua',
  eyebrow: 'Danza D9 · NIK 2026',
  heroTitle: 'New Danza D9 generasi kedua: lebih bertenaga, lebih jauh, lebih aman',
  heroText: `MPV listrik premium pemimpin segmennya kini masuk generasi kedua. Baterai naik ke 115 kWh, tenaga dari 230 ke 340 kW, jarak tempuh 730 km, dan daftar fitur keselamatan bertambah panjang. Harga ${PRICE.price} OTR Jakarta di BYD BSD Serpong.`,
  modelPath: '/jelajahi-denzad9',
  modelLabel: 'Lihat halaman Danza D9',
  waMessage: `Halo Junius, saya baca artikel Danza D9 NIK 2026 dan tertarik dengan unit seharga ${PRICE.price}. Mohon info interior Black, promo, dan jadwal test drive.`,
  quickSpecs: [
    { label: 'Harga OTR Jakarta', value: 'Rp1,08 miliar' },
    { label: 'Jarak tempuh NEDC', value: '730 km' },
    { label: 'Tenaga', value: '340 kW' },
    { label: '0-100 km/jam', value: '8,5 detik' },
    { label: 'Baterai', value: 'Blade 2.0 115 kWh' },
  ],
  sections: [
    {
      title: 'Dari Denza ke Danza, dari generasi pertama ke generasi kedua',
      paragraphs: [
        'Brand premium BYD di Indonesia kini resmi bernama Danza, dan model pertama yang membawanya adalah D9. Sejak meluncur, D9 menjadi pemimpin segmen MPV premium listrik dan diterima kuat oleh keluarga maupun pengusaha yang ingin alternatif Alphard dengan biaya operasional jauh lebih rendah. Untuk NIK 2026, Danza menghadirkan generasi kedua dengan pembaruan besar di baterai, tenaga, suspensi, audio, dan keselamatan, sementara penggeraknya tetap roda depan.',
        'Secara tampilan, perubahannya halus: emblem belakang baru yang lebih bersih, pilihan ban Bridgestone HL 235/60 R18, dan tinggi bodi turun 20 mm menjadi 1.900 mm. Perubahan terbesar justru ada di balik bodi.',
      ],
    },
    {
      title: 'Blade Battery 2.0: 730 km dan Flash Charging 9 menit',
      paragraphs: [
        'Generasi pertama memakai Blade Battery 103,36 kWh dengan jarak 600 km NEDC. Generasi kedua naik ke Blade Battery 2.0 berkapasitas 115,07 kWh dengan jarak tempuh 730 km NEDC. Bedanya terasa saat perjalanan Jakarta ke Bandung pulang pergi tanpa perlu mengisi daya.',
        'Yang lebih menarik adalah pengisiannya. Dengan BYD Flash Charger, D9 generasi kedua bisa diisi dari 0 ke 97 persen dalam sekitar 9 menit. Untuk pemilik MPV yang sering dipakai antar jemput seharian, waktu tunggu sesingkat ini mengubah cara memakai mobil listrik.',
      ],
    },
    {
      title: 'Tenaga 340 kW dan suspensi DiSus-C',
      paragraphs: [
        'Motor depan kini menghasilkan 340 kW dan 365 Nm, naik dari 230 kW dan 360 Nm. Akselerasi 0-100 km/jam turun dari 9,5 menjadi 8,5 detik, cukup untuk menyalip dengan percaya diri meski kabin penuh tujuh penumpang. Suspensi berubah dari FSD ke DiSus-C Intelligent Damping Body Control yang menyesuaikan redaman secara aktif, sehingga guncangan di jalan bergelombang tidak sampai mengganggu penumpang baris kedua yang sedang dipijat.',
      ],
    },
    {
      title: 'Kabin: interior Black baru, pijat 10 titik, Devialet 16 speaker',
      paragraphs: [
        'Pilihan interior bertambah dengan warna Black yang sporty di samping Brown yang elegan. Kursi baris kedua kini punya pijat 10 titik, naik dari 6 titik, dan kursi depan mendapat pemanas serta pijat selain ventilasi dan memori. Kursi baris ketiga menjadi elektrik 4 arah dengan lipat elektrik, bisa dikendalikan dari tombol di bagasi, dan tata letak kursi bisa diubah satu sentuhan dari layar untuk mode 4 penumpang, 7 penumpang, atau 7 penumpang dengan bagasi penuh.',
        'Audio Dynaudio 14 speaker diganti Devialet 16 speaker, wireless charging depan menjadi dua unit 50 W, perintah suara mengenali 6 zona, dan transmisi pindah ke steering column shifter sehingga konsol tengah lebih lega. Kapasitas bagasi melonjak dari 410 menjadi 689 liter, atau 2.436 liter saat baris ketiga dilipat.',
      ],
    },
    {
      title: 'Keselamatan: 9 airbag, CPD, DFM, dan dashcam bawaan',
      paragraphs: [
        'Airbag bertambah menjadi 9 dengan far side airbag untuk penumpang depan. Child Presence Detection memakai radar untuk mendeteksi napas dan detak jantung dalam 15 detik setelah mobil dikunci, lalu membunyikan peringatan dan menyalakan AC bila kabin terlalu panas. Driver Fatigue Monitoring memantau kedipan dan posisi kepala pengemudi, dashcam terpasang dari pabrik, seat belt reminder mencakup baris ketiga, dan spion tengah menjadi auto-dimming. ADAS dilengkapi Front Cross Traffic Alert dan Braking.',
      ],
    },
    {
      title: 'Harga Danza D9 NIK 2026 dan simulasi singkat',
      paragraphs: [
        `Harga New Danza D9 NIK 2026 adalah ${PRICE.price} OTR Jakarta untuk varian FWD, dengan empat warna eksterior: Cosmos Black, Arctic White, Starry Night Grey, dan Whale Sea Blue. Dengan uang muka 20 persen atau sekitar Rp216 juta, sisa pembiayaan sekitar Rp864 juta yang angsurannya bergantung tenor dan lembaga pembiayaan. Sebagai mobil listrik, D9 bebas ganjil genap di Jakarta dan pajak tahunannya jauh lebih ringan dibanding MPV bensin sekelas.`,
        'Unit bisa dilihat dan dicoba di BYD Arista BSD City. Hubungi Junius untuk promo berjalan, ketersediaan warna dan interior, serta jadwal test drive.',
      ],
    },
  ],
  specTitle: 'D9 generasi pertama vs New D9 NIK 2026',
  specRows: [
    ['Harga OTR Jakarta', `${PRICE.price} (NIK 2026)`],
    ['Baterai', '103,36 kWh → Blade Battery 2.0 115,07 kWh'],
    ['Jarak tempuh NEDC', '600 km → 730 km'],
    ['Tenaga / torsi motor depan', '230 kW / 360 Nm → 340 kW / 365 Nm'],
    ['Akselerasi 0-100 km/jam', '9,5 detik → 8,5 detik'],
    ['Pengisian cepat', 'DC fast charging → Flash Charging 0-97% sekitar 9 menit'],
    ['Suspensi', 'FSD → DiSus-C'],
    ['Audio', 'Dynaudio 14 speaker → Devialet 16 speaker'],
    ['Pijat kursi baris 2', '6 titik → 10 titik'],
    ['Kursi baris 3', 'Manual → elektrik 4 arah + lipat elektrik'],
    ['Airbag', '8 → 9'],
    ['Bagasi', '410 / 2.310 L → 689 / 2.436 L'],
    ['Dimensi (P x L x T)', '5.250 x 1.960 x 1.920 → 5.250 x 1.960 x 1.900 mm'],
    ['Radius putar', '5,95 m → 5,85 m'],
    ['Pilihan interior', 'Brown → Brown dan Black'],
  ],
  specNote: 'Perbandingan mengikuti materi product knowledge resmi Danza Indonesia untuk New D9 2nd Generation (FWD).',
  galleryTitle: 'New Danza D9 NIK 2026',
  gallery: [
    { src: colorBlack, ratio: 60, fit: 'contain', bg: STUDIO_BG, alt: 'Danza D9 warna Cosmos Black', title: 'Cosmos Black', text: 'Satu dari empat warna eksterior resmi NIK 2026.' },
    { src: colorBlue, ratio: 60, fit: 'contain', bg: STUDIO_BG, alt: 'Danza D9 warna Whale Sea Blue', title: 'Whale Sea Blue', text: 'Warna biru khas Danza untuk D9.' },
    { src: colorGrey, ratio: 60, fit: 'contain', bg: STUDIO_BG, alt: 'Danza D9 warna Starry Night Grey', title: 'Starry Night Grey', text: 'Abu-abu gelap elegan, pilihan baru generasi kedua.' },
    { src: interiorBrown, ratio: 60, alt: 'Interior Danza D9 warna Brown', title: 'Interior Brown', text: 'Kabin elegan dengan captain seat baris kedua berpijat 10 titik.' },
    { src: interiorCabin, ratio: 60, alt: 'Kabin Danza D9 dengan layar dan kursi captain', title: 'Kabin premium', text: 'Tiga baris kursi, mode tata letak satu sentuhan dari layar.' },
    { src: sunroof, ratio: 60, alt: 'Sunroof panoramik Danza D9', title: 'Panoramic sunroof', text: 'Kabin terasa lapang dan terang.' },
  ],
  faqs: [
    {
      q: 'Apa beda Danza D9 NIK 2026 dengan D9 sebelumnya?',
      a: 'Generasi kedua memakai Blade Battery 2.0 115 kWh dengan jarak 730 km NEDC, tenaga 340 kW, Flash Charging 9 menit, suspensi DiSus-C, audio Devialet 16 speaker, 9 airbag, kursi baris ketiga elektrik, pijat 10 titik, bagasi 689 liter, dan pilihan interior Black.',
    },
    {
      q: 'Berapa harga Danza D9 NIK 2026?',
      a: `${PRICE.price} OTR Jakarta untuk varian FWD. Hubungi Junius untuk promo dan simulasi pembiayaan.`,
    },
    {
      q: 'Apakah Danza D9 masih FWD?',
      a: 'Ya. Versi Indonesia tetap berpenggerak roda depan dengan satu motor, kini bertenaga 340 kW.',
    },
    {
      q: 'Apakah Danza D9 bebas ganjil genap?',
      a: 'Ya. Sebagai mobil listrik murni, D9 bebas aturan ganjil genap di Jakarta dan pajak kendaraan tahunannya jauh lebih ringan.',
    },
    {
      q: 'Apakah Denza D9 lama bisa mendapat fitur generasi kedua?',
      a: 'Tidak. Pembaruan baterai, motor, suspensi, dan fitur keselamatan adalah perubahan perangkat keras pada unit NIK 2026. Garansi dan layanan untuk pemilik D9 generasi pertama tetap berjalan seperti biasa.',
    },
  ],
  related: [
    { label: 'Halaman model Danza D9: pilihan warna, interior, dan tabel perbandingan', to: '/jelajahi-denzad9' },
    { label: 'Danza D9 Indonesia: MPV listrik mewah pesaing Alphard', to: '/blog/denza-d9-indonesia-mpv-mewah' },
    { label: 'Danza Z9 GT Indonesia: shooting brake listrik 1.156 PS', to: '/blog/danza-z9-gt-indonesia-shooting-brake-listrik' },
    { label: 'Daftar harga BYD dan Danza terbaru', to: '/pricing' },
  ],
  ctaTitle: 'Coba New Danza D9 di BYD BSD Serpong',
  ctaText:
    'Hubungi Junius untuk promo Danza D9 NIK 2026, ketersediaan interior Black, simulasi pembiayaan, dan jadwal test drive.',
  product: {
    name: 'Danza D9',
    alternateName: 'Denza D9',
    description: 'MPV listrik premium Danza D9 NIK 2026 generasi kedua dengan Blade Battery 2.0 115 kWh, 340 kW, dan jarak 730 km NEDC.',
    price: PRICE.priceValue,
  },
};

function DanzaD9Nik2026Article() {
  return <ModelArticle article={article} />;
}

export default DanzaD9Nik2026Article;
